import React, {useEffect, useMemo, useState} from 'react'
import Dropzone from 'react-dropzone'
import { useForm } from 'react-hook-form'
import { Editor, EditorTools } from "@progress/kendo-react-editor";
import { ExpandMore } from '@material-ui/icons'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Button, Grid, Dialog, DialogActions, DialogContent, DialogContentText, ButtonProps,  Accordion,
  AccordionDetails,
  AccordionSummary } from '@material-ui/core'
import { styled } from '@mui/material/styles';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Alerts from '../../components/common/Alerts'
import HookForm from '../../components/common/HookForm'
import { Controller} from 'react-hook-form'
import CheckboxGroup from '../../components/common/inputs/CheckboxGroup'
import SelectInput from '../../components/common/inputs/SelectInput'
import TextInput from '../../components/common/inputs/TextInput'
import {EvtState, setEvt, useEvtState} from '../../slices/evtSlice'
import styles from './EventPageBuilder.module.css'
import {Lock, LockOpen, Close } from '@material-ui/icons'
import dayjs from "dayjs";
import {Dayjs} from "dayjs";

import {useHistory} from "react-router-dom";
import {useDispatch} from "react-redux";
import {useParams} from "react-router";
 import {useAutoEvent} from "../../queries/useAutoEvent";
import {AuthToken, useAuthToken} from "../../slices/authSlice";
import {useFetchOrgSettings} from "../OrgSettingsPage/useFetchOrgSettings";
import {OrgState, setOrg, useOrgState} from "../../slices/orgSlice";
import imageCompression from "browser-image-compression";
import axios from "axios";
import {useAutoEvt} from "../../queries/useAutoEvt";
import BeefreeSDK from '@beefree.io/sdk'
import {parseJwt} from "../AuthPage/LoginForm/useLoginMutation";
import {BeeSaveOptions} from "@beefree.io/sdk/dist/types/bee";

interface Params {
  id: string
}

const EventPageBuilder = ({ isEdit = false }) => {
    const { id } = useParams<Params>()
    useAutoEvt(id)
    const formMethods = useForm<FormData>()
    const authToken = useAuthToken()
    const [landingPage, setLandingPage] = React.useState<string>("");
    const [landingPageHTML, setLandingPageHTML] = React.useState<string>("");
    const setTemplates = async (eventId, templateString, templageHTML) => {
        const htmlString = JSON.stringify(templageHTML)
        const body = {eventid: eventId, landing: JSON.stringify(templateString), landinghtml: htmlString}
        const {data} = await axios.put('/evtsettingslanding', body)
    }

    useEffect(() => {
        if (landingPage.length > 0) {
            setTemplates(id, landingPage, landingPageHTML)
        }
    }, [landingPage])


    useEffect(() => {
        const getTemplates = async (eventId) => {
            const json = JSON.stringify({ eventid: eventId })
            const { data } = await axios.post('/evtsettingslanding', json, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            const parsedData = JSON.parse(data.jsonString)
            const clientId = '4f7cf95b-2e6c-49e4-8aae-2864cb3fb28b'
            const clientSecret = '7uSLILyx60ck4fZfi0shgAe6zM8eRYQt9yW1YKuFEeSakJFkggyP'

            const token = localStorage.getItem('tokenadmin')
            const parsedToken: AuthToken = parseJwt(token)
            const configuration = {
                uid: parsedToken?.sitecode,  // Change this to fit your project
                container: 'bee-plugin-container',
                trackChanges: true,
                onSave: function(jsonFile, htmlFile) {
                    setLandingPageHTML(htmlFile)
                    setLandingPage(jsonFile)
                },
                // onChange: function(jsonFile, htmlFile) {
                //     setLandingPage(jsonFile)
                //     setLandingPageHTML(htmlFile)
                // },
            }
            const sdk = new BeefreeSDK();
            const tokenObj = await sdk.getToken(clientId, clientSecret)
            if (parsedData?.landinghtml?.length > 0) {
                setLandingPageHTML(JSON.parse(parsedData?.landinghtml))
            }
            if (parsedData?.landing?.length > 0) {
                setLandingPage(JSON.parse(parsedData?.landing))
            }

            const beeSDK = await sdk.start(configuration, parsedData?.landing?.length > 50 ? JSON.parse(parsedData?.landing) : {})
        }
        getTemplates(id)
    }, [])

    return (
        <div className={styles.root}>
            <h1>Event Page Builder</h1>
            <HookForm
                methods={formMethods}
                onSubmit={() => {}}
                className={styles.form}
                formProps={{ id: 'EventPageBuilder-form-new' }}>
                {/*<LoadingBackdrop open={isFetching} />*/}

                <div style={{height: '600px'}} id="bee-plugin-container"></div>

                {/*<FloatingButton*/}
                {/*    type="submit"*/}
                {/*    variant="contained"*/}
                {/*    className={styles.button}*/}
                {/*    form="EventSettings-form-new"*/}
                {/*>*/}
                {/*    Save*/}
                {/*</FloatingButton>*/}
            </HookForm>
        </div>
    )
}

export default EventPageBuilder
